<div class="d-flex flex-row justify-content-between mb-y">
  <app-badge *ngIf="badge && badge.length > 0" [badge]="badge"></app-badge>
  <app-wishlist class="ms-auto" [product]="product"></app-wishlist>
</div>
<div class="mb-z">
  <h1 class="display-1">
    {{
      product.title.includes(" | ")
        ? product.title.split(" | ")[0].split(" - ")[0]
        : product.title
    }}
  </h1>
  <h3 class="fw-bold" *ngIf="product.title.split(' | ')[0].split(' - ')[1]">
    {{
      product.title.includes(" | ")
        ? product.title.split(" | ")[0].split(" - ")[1]
        : product.title
    }}
  </h3>
</div>
<app-price [product]="product"></app-price>
<app-reviews class="mb-x" [product]="product"></app-reviews>
<div
  *ngIf="_description || product.body_html"
  class="description mb-x"
  [innerHtml]="_description || product.body_html"
></div>
@defer {
<app-variant-picker
  *ngIf="product"
  class="mb-x"
  [product]="product"
></app-variant-picker>
<app-add-to-cart [product]="product" class="mb-x"></app-add-to-cart>
} @placeholder {
<div></div>
}
<div class="accordions mb-y">
  <app-accordion
    *ngFor="let accordion of accordions; let last = last"
    [title]="accordion.title"
    [caret]="true"
    [ngClass]="{ 'border-bottom': !last }"
    [body]="accordion.content"
  ></app-accordion>
</div>
